document.addEventListener('DOMContentLoaded', function () {
    let jsCounter = Array.prototype.slice.call(document.querySelectorAll('.counter-animation'));

    jsCounter.forEach(function (self) {
        let counter = self.querySelector('.counter').getAttribute('count');

        gsap.to(self.querySelector('.line-inner'), {
            scrollTrigger: self, width: '100%', duration: 1.5
        });

        gsap.to(self.querySelector('.counter'), {
            scrollTrigger: self, innerText: counter, duration: 1.5,
            snap: {
                innerText: 1
            }
        });
    });
});
